import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { UserTableComponent } from './user-table.component';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { ConfigureUserDialogModule } from '../configure-user-dialog/configure-user-dialog.module';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [UserTableComponent],
  imports: [
    CommonModule,
    TableModule,
    AvatarModule,
    TagModule,
    ButtonModule,
    MenuModule,
    ConfirmDialogModule,
    MessageModule,
    ToastModule,
    DialogModule,
    DynamicDialogModule,
    ConfigureUserDialogModule,
    TooltipModule
  ],
  exports: [UserTableComponent],
  providers: [DatePipe],
})
export class UserTableModule {}
